import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'antd'
import ButtonBlack from 'components/design/Form/ButtonBlack'
import FormInput from '../../design/Form/Input'
import LinkPurple from '../../design/Form/LinkPurple'
import authStyle from '../../../layouts/Auth/style.module.scss'
import style from './style.module.scss'

const ForgotPasswordForm = () => {
  const [form] = Form.useForm()
  const [email, setEmail] = useState('')
  const user = useSelector(state => state.user)
  const dispatch = useDispatch()

  const onFinish = values => {
    dispatch({
      type: 'user/REQUEST_RESET_PASSWORD_EMAIL',
      payload: values,
    })
  }

  const handleEmailInput = e => {
    setEmail(e.target.value)
  }

  return (
    <div className={style.cometchatForgotPassword}>
      <div className={style.cometchatForgotPasswordContentWrapper}>
        <div className={style.cometchatForgotPasswordHeader}>
          <div className={style.cometchatForgotPasswordTitle}>Forgot Password?</div>
          <div className={style.cometchatForgotPasswordSubtitle}>
            Enter your email and we’ll send you instructions to reset your password
          </div>
        </div>
        <div className={style.cometchatForgotPasswordContent}>
          <Form
            form={form}
            hideRequiredMark
            onFinish={onFinish}
            initialValues={{ email }}
            style={{ width: '100%' }}
          >
            <FormInput
              onChange={handleEmailInput}
              Form={Form}
              label={<div className={style.cometchatForgotPassInputLabel}>Email</div>}
              style={{ height: '44px', borderColor: '#d5d7da' }}
              autoFocus
              name="email"
              value={email}
              placeholder="Enter your email"
              rules={[
                { required: true, message: 'Please enter your email' },
                {
                  type: 'email',
                  message: 'Please enter a valid email',
                },
              ]}
              className={style.noMarginInput}
            />
            <ButtonBlack
              holderStyles={{ marginTop: '40px' }}
              buttonStyles={{
                height: '44px',
                fontSize: '16px',
              }}
              buttonText="Reset password"
              buttonType="submit"
              loading={user.loading}
            />
          </Form>
          <div className={authStyle.signupLoginWrapper}>
            <LinkPurple
              to="/login"
              linktext={
                <div className={style.cometchatForgotPasswordLogin}>
                  <div className={style.cometchatForgotPasswordLoginIcon} />
                  Back to log in
                </div>
              }
              classes={style.logInLink}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordForm
